<template>
  <div>
    <nav
      class="navbar navbar-expand navbar-dark bg-secondary justify-content-between"
    >
      <span class="navbar-brand">
        <a href="/tester/home"> OneEd Testing System for Testers</a>
      </span>
      <button
        type="button"
        class="btn btn-outline-light"
        @click="localEventHandler('click-logout')"
      >
        Logout
      </button>
    </nav>
    <div class='p-2'>
      <router-view />
    </div>
  </div>
</template>

<script>
import auth from '@/app/auth'
export default {
  name: 'Tester',
  methods: {
    localEventHandler (name, event) {
      if (name == 'click-logout') {
        auth.logout()
      }
    }
  }
}
</script>

<style scoped>
a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}
</style>
